module.exports = __webpack_public_path__ + "static/user-0c58337b007e77fc90324af55e44cf6e.png";